import {
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";

import { NgxTippyProps } from "ngx-tippy-wrapper";

@Component({
  selector: "app-accordion",
  templateUrl: "./accordion.component.html",
  styleUrls: ["./accordion.component.scss"],
  // encapsulation: ViewEncapsulation.None
})
export class AccordionComponent implements OnInit {
  @ViewChild("tippyTemplatePassElement", { read: ElementRef, static: false })
  tippyTemplatePassElement: ElementRef;
  // @ViewChild("templatePassInnerHTML", { read: ElementRef, static: false })
  // templatePassInnerHTML: ElementRef;
  @Input() meritData: any = {};
  @Input() costOfAttendanceData = [];
  @Input() meritScholerShipData = [];
  @Input() federalAidData = [];
  @Input() StateAidData = [];
  @Input() collegeWiseProgramList = [];
  @Input() ComparisionMatrixList = [];

  @Input("type") type: string = "";
  @Input() ComparisionList = [];
  isOpenMeritInfoRange = false;

  public readonly bindedContent: string = "Binded tooltip content";

  tippyPropsLeft = {
    placement: "top-start",
    arrow: false,
    theme: "light",
    delay: 500,
  };
  tippyProps = {
    placement: "top",
    arrow: true,
    theme: "light",
    delay: 500,
  };
  // private instancesChanges$: Subscription;

  public baseProps: NgxTippyProps = {
    arrow: true,
    theme: "light",
    delay: 500,
  };

  // fromComponent: NgxTippyProps = {
  //   ...this.baseProps,
  //   arrow: false,
  //   placement: "bottom"
  // };

  // binding: NgxTippyProps = { ...this.baseProps, content: this.bindedContent };

  // bindedProp: NgxTippyProps = { ...this.baseProps, placement: "bottom" };

  templateRef: NgxTippyProps = {
    ...this.baseProps,
    allowHTML: true,
    appendTo: "parent",
    interactive: true,
    interactiveBorder: 50,
  };

  // passElement: NgxTippyProps = this.templateRef;
  passInnerHTML: NgxTippyProps = this.templateRef;

  // plugin: NgxTippyProps = {
  //   ...this.baseProps,
  //   followCursor: true,
  //   plugins: [followCursor]
  // };

  // animateFill: NgxTippyProps = { animateFill: true, plugins: [animateFill] };

  // manualControl: NgxTippyProps = {
  //   allowHTML: true,
  //   animation: "shift-away",
  //   content: "Tooltip content",
  //   hideOnClick: false,
  //   interactive: true,
  //   interactiveBorder: 50,
  //   theme: "light",
  //   trigger: "manual"
  // };

  // grouped: NgxTippyProps = this.templateRef;
  constructor() {}

  ngOnInit(): void {
    console.log(this.meritScholerShipData, "Meritigdfkgdjgkdjgdkgjdk;gjdfgk");

    //this.getMeritGrandAid();
  }

  openInfoMeritRange() {
    this.isOpenMeritInfoRange = !this.isOpenMeritInfoRange;
  }
  nan(value) {
    return isNaN(value);
  }

  // getMeritGrandAid()
  // {

  //   let totalamt;
  //   let meritBasedAid=this.meritData.institutionalGrants.meritBasedAid;
  //   Object.keys(meritBasedAid).forEach((key) => {
  //      totalamt += meritBasedAid[key].amount;
  //   });

  // }

  handleyear(year: number) {
    if (year) {
      if (year > 99) {
        return "99+ years";
      } else {
        return year + " years";
      }
    } else {
      return "-";
    }
  }
  activeItemIndex: number = 0; // Default to GPA

  showData(tab: string) {
    this.activeItemIndex = tab === "gpa" ? 0 : 1;
  }

  // getSelectedData() {
  //   return this.meritAmt?.meritRange || [];
  // }
  getValuesBasedOnTab(meritRange: any): any[] {
    let data = [];

    if (this.activeItemIndex === 0 && meritRange?.gpa) {
      data = meritRange?.gpa;
    } else if (this.activeItemIndex === 1 && meritRange?.act) {
      data = meritRange?.act;
    }

    // Sort data in ascending order based on gpa or act
    data.sort((a, b) => (a.gpa || a.act) - (b.gpa || b.act));

    return data;
  }
}
